<template>
  <section>
    <div>
      <slot name="bodyTop" />
      <form v-on:submit.prevent="onSubmit">
        <slot />
      </form>
      <slot name="bodyBottom" />
    </div>
    <footer>
      <slot name="footerTop" />
      <divider />
      <FieldWrapper>
        <captcha
          name="captcha"
          tabindex="2"
          @verified="onCaptchaVerified"
          data-vv-scope="form"
          v-model="recaptchaResponse"
        />
        <div slot="errors" v-if="errors.has('captcha', 'form')">
          {{ errors.first("captcha", "form") }}
        </div>
      </FieldWrapper>
      <slot name="footerBottom" />
    </footer>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "form-with-captcha",
  props: {
    requestData: {
      type: Object,
      default() {
        return {};
      }
    },
    afterCaptchaVerified: {
      type: Function,
      required: true
    }
  },
  data() {
    //c588921c-7d2e-4c8c-acae-337f8564907e
    return {
      recaptchaResponse: null,
      loading: false
    };
  },
  computed: {
    ...mapGetters("config", {
      recaptcha: "getRecaptcha"
    })
  },
  watch: {
    loading(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit("loading", newVal);
      }
    }
  },
  methods: {
    async onCaptchaVerified() {
      try {
        this.loading = true;
        const response = await this.afterCaptchaVerified(
          Object.assign(this.requestData, {
            "g-recaptcha-response": this.recaptchaResponse
          })
        );

        this.$emit("success", response);
      } catch (e) {
        this.$emit("error", e);
        this.EventBus.$emit(this.events.CAPTCHA_RESET);
      } finally {
        this.loading = false;
      }
    },
    onSubmit() {
      this.$validator.validateAll("form").then(valid => {
        if (valid) {
          this.EventBus.$emit(this.events.CAPTCHA_EXECUTE);
        } else {
          this.EventBus.$emit(this.events.CAPTCHA_RESET);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
